import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../model/authApi";
import { setAuth } from "../model/authSlice";
import { useAppDispatch } from "@/shared/hooks";
import { validateEmail, validatePassword } from "../lib/validation";
import fondLogo from "@/assets/fond_start1.png";
import styles from "./AuthPage.module.scss";

export const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<{ email?: string; password?: string; general?: string }>({});
  const [login, { isLoading }] = useLoginMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErrors({});

    if (!validateEmail(email)) {
      setErrors({ email: "Invalid email address" });
      return;
    }

    const passwordValidation = validatePassword(password);
    if (!passwordValidation.valid) {
      setErrors({ password: passwordValidation.error });
      return;
    }

    try {
      const result = await login({ email, password }).unwrap();
      
      // Сохраняем токены в Redux store и localStorage
      dispatch(setAuth({ 
        token: result.access_token, 
        refreshToken: result.refresh_token,
        userId: result.user_id 
      }));
      
      // Даем время на обновление Redux store и localStorage
      await new Promise(resolve => setTimeout(resolve, 150));

      // После логина всегда ведем на /trains.
      // Логика fallback на /quiz при отсутствии тренировок выполняется на /trains.
      navigate("/trains", { replace: true });
    } catch (err: any) {
      setErrors({ general: err?.data?.detail || "Login failed" });
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authContainer}>
        <h1 className={styles.title}>Вход</h1>
        <form onSubmit={handleSubmit} className={styles.form}>
          {errors.general && <div className={styles.error}>{errors.general}</div>}
          <div className={styles.field}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={errors.email ? styles.inputError : ""}
              required
            />
            {errors.email && <span className={styles.fieldError}>{errors.email}</span>}
          </div>
          <div className={styles.field}>
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={errors.password ? styles.inputError : ""}
              required
            />
            {errors.password && <span className={styles.fieldError}>{errors.password}</span>}
          </div>
          <button type="submit" className={styles.submitButton} disabled={isLoading}>
            {isLoading ? "Вход..." : "Войти"}
          </button>
        </form>
        <div className={styles.footer}>
          <span>Нет аккаунта? </span>
          <a href="/register" className={styles.link}>
            Зарегистрироваться
          </a>
        </div>
        <div style={{ textAlign: "center", marginTop: "32px" }}>
          <img src={fondLogo} alt="FitKeep Logo" style={{ width: "100px", height: "auto" }} />
        </div>
      </div>
    </div>
  );
};



